import { HttpAxiosRequest } from "./httpAxiosRequest";
import { SuscripcionCampoAdicionalVista } from "../types/camposAdicionales";

export const HttpCamposAdicionales = {
    obtenerDeOrden: (): Promise<SuscripcionCampoAdicionalVista[]> =>
        HttpAxiosRequest.get("/tienda/suscripcion-campos-adicionales/orden"),
};
